import type { PromotionReclaimableReminderResponse } from '@promotion/types'
import { useApi, useQuery, useUserInfo } from '#imports'

export const usePromotionReclaimableReminder = () => {
    const api = useApi({ enableLegacySupport: true, service: 'monolith' })
    const { isLoggedIn } = useUserInfo()

    return useQuery<PromotionReclaimableReminderResponse['reminder']>(async () => {
        const response = await api<PromotionReclaimableReminderResponse>('/rewards/reclaimable_reminder')

        return response.reminder
    }, {
        key: 'promotion:reclaimable-reminder',
        enabled: isLoggedIn,
        lazy: true,
        server: false,
    })
}
